export default __webpack_public_path__ + "src/images/ball/0-51bfd1.png";